import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Typography, Badge, Box, Stack, Grid, useMediaQuery } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
  DownloadOutlined,
  //  ReloadOutlined
  TableOutlined
} from '@ant-design/icons';
import IconButton from 'components/@extended/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Menu, MenuItem } from '@mui/material';
import { openSnackbar } from 'store/reducers/snackbar';

// import MainCard from 'components/MainCard';
// import PremiumUnlockGroup from './PremiumUnlockGroup';
import { setAnalysisUrl, setCurrentTaskId, setExtendedAnalysisResults, setIcpHistoryResult } from 'store/reducers/actions';
import { useEffect, useState, useRef } from 'react';
import ExtendedAnalysisGroup from './ExtendedAnalysisGroup';
import FreeBlockModal from 'sections/premiumBlock/FreeBlockModal';

import { openModal } from 'store/reducers/actions';
import NewOverviewSection from './NewOverviewSection';
// import { addChatContext, removeChatContext } from 'store/reducers/chatContext';
import exportLpAnalysisDocx from 'utils/exportDocx';
// import PricingAnalysisSection from './PricingAnalysisSection';

const AnalysisOutputGroup = ({ processSubmit }) => {
  const { taskId } = useParams();
  const rawAnalysisData = useSelector((state) => state.analysisReducer.response);
  const plan = useSelector((state) => state.proAccountReducer.plan);
  // const isNotFreePlan = plan !== 'Free';
  const isProPlan = plan === 'Pro' || plan === 'Pro+' || plan === 'Enterprise Pro Max' || plan === 'Enterprise Pro';
  // const lastUrl = useSelector((state) => state.analysisUrlReducer);
  // const matchDownLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [lastRawAnalysisData, setLastRawAnalysisData] = useState(null);
  const [lastHistoryResult, setLastHistoryResult] = useState(null);
  const [loadNew, setLoadNew] = useState(null);
  const [isDownloadClicked, setDownloadClicked] = useState(false);
  const [isTableView, setIsTableView] = useState(false);
  // const sections = [
  //   { id: 'overview', title: 'Overview' },
  //   // { id: 'business-analysis', title: 'Business Analysis' },
  //   { id: 'usp', title: 'USP' },
  //   { id: 'segmentation', title: 'Segmentation' },
  //   { id: 'icp-profile', title: 'ICP Profile' },
  //   { id: 'market-overview', title: 'Market Overview' },
  //   { id: 'swot', title: 'SWOT' }
  // ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (taskId) {
      dispatch(setCurrentTaskId(taskId));
    }
  }, [taskId, dispatch]);

  const historyResult = useSelector((state) => state.historyReducer.historyResult);
  const extendedAnalysisResults = useSelector((state) => state.extendedAnalysisReducer.extendedAnalysisResults);

  // Debug Redux state
  console.log('AnalysisOutputGroup: historyResult:', historyResult);
  console.log('AnalysisOutputGroup: extendedAnalysisResults:', extendedAnalysisResults);

  // const chatContexts = useSelector((state) => state.chatContext.contexts);
  const selectedElements = useSelector((state) => state.chatContext.selectedElements);
  const selectedTextRanges = useSelector((state) => state.chatContext.selectedTextRanges);
  const isChatOpen = useSelector((state) => state.chatContext.isChatOpen);

  const generateElementId = (element) => {
    // Generate a unique ID based on element content and position
    const content = element.innerText.substring(0, 50);
    const rect = element.getBoundingClientRect();
    return `element-${content.replace(/\s+/g, '-').toLowerCase()}-${Math.round(rect.top)}-${Math.round(rect.left)}`;
  };

  // const createTextRange = (selection) => {
  //   if (!selection.rangeCount) return null;

  //   const range = selection.getRangeAt(0);

  //   // Create a unique ID for this text range
  //   const rangeId = `text-range-${Date.now()}-${Math.random()}`;

  //   // Only store serializable data - NO DOM NODES!
  //   return {
  //     id: rangeId,
  //     text: selection.toString(),
  //     // Store serialized range for recreation
  //     rangeData: {
  //       startXPath: getXPathForNode(range.startContainer),
  //       endXPath: getXPathForNode(range.endContainer),
  //       startOffset: range.startOffset,
  //       endOffset: range.endOffset
  //     }
  //   };
  // };

  // const getXPathForNode = (node) => {
  //   if (node.nodeType === Node.DOCUMENT_NODE) return '';

  //   let xpath = '';
  //   let currentNode = node;

  //   while (currentNode && currentNode.nodeType !== Node.DOCUMENT_NODE) {
  //     let index = 0;
  //     let sibling = currentNode.previousSibling;

  //     while (sibling) {
  //       if (sibling.nodeType === currentNode.nodeType && sibling.nodeName === currentNode.nodeName) {
  //         index++;
  //       }
  //       sibling = sibling.previousSibling;
  //     }

  //     const tagName = currentNode.nodeType === Node.ELEMENT_NODE ? currentNode.tagName.toLowerCase() : 'text()';
  //     xpath = `/${tagName}[${index + 1}]${xpath}`;
  //     currentNode = currentNode.parentNode;
  //   }

  //   return xpath;
  // };

  // const handleMouseUp = (event) => {
  //   // Only handle selections when chat is open (beta feature)
  //   if (!isChatOpen) return;

  //   const selection = window.getSelection();
  //   const selectedText = selection.toString().trim();

  //   if (selectedText) {
  //     // Handle text selection
  //     const textRange = createTextRange(selection);
  //     if (textRange) {
  //       // Check if this text is already selected by comparing content
  //       const existingTextContext = chatContexts.find((ctx) => ctx.selectionType === 'text' && ctx.content === selectedText);

  //       if (existingTextContext) {
  //         // Remove if already selected
  //         dispatch(removeChatContext(existingTextContext.id));
  //         dispatch(
  //           openSnackbar({
  //             open: true,
  //             message: `Text context removed! (${chatContexts.length - 1} total)`,
  //             variant: 'alert',
  //             alert: { color: 'warning' },
  //             autoHideDuration: 2000
  //           })
  //         );
  //       } else {
  //         // Add text selection
  //         dispatch(addChatContext(selectedText, null, 'text', textRange));
  //         dispatch(
  //           openSnackbar({
  //             open: true,
  //             message: `Context added from selected text! (${chatContexts.length + 1} total)`,
  //             variant: 'alert',
  //             alert: { color: 'success' },
  //             autoHideDuration: 2000
  //           })
  //         );
  //       }
  //     }

  //     // Clear the selection to avoid visual artifacts
  //     selection.removeAllRanges();
  //   } else {
  //     // Handle card selection
  //     const cardElement = event.target.closest('.MuiCard-root');
  //     if (cardElement) {
  //       const elementId = generateElementId(cardElement);
  //       const existingContext = chatContexts.find((ctx) => ctx.elementId === elementId);

  //       if (existingContext) {
  //         // Remove if already selected
  //         dispatch(removeChatContext(existingContext.id));
  //         dispatch(
  //           openSnackbar({
  //             open: true,
  //             message: `Context removed from card! (${chatContexts.length - 1} total)`,
  //             variant: 'alert',
  //             alert: { color: 'warning' },
  //             autoHideDuration: 2000
  //           })
  //         );
  //       } else {
  //         // Add if not selected
  //         dispatch(addChatContext(cardElement.innerText, elementId, 'card'));
  //         dispatch(
  //           openSnackbar({
  //             open: true,
  //             message: `Context added from clicked card! (${chatContexts.length + 1} total)`,
  //             variant: 'alert',
  //             alert: { color: 'success' },
  //             autoHideDuration: 2000
  //           })
  //         );
  //       }
  //     }
  //   }
  // };

  const historyExtendedAnalysisResults = {
    business_analysis: historyResult?.business_analysis,
    usp: historyResult?.usp,
    market_overview: historyResult?.market_overview,
    market_trends_and_benchmarks: historyResult?.market_trends_and_benchmarks,
    segmentation: historyResult?.segmentation,
    swot: historyResult?.swot,
    icp: historyResult?.icp, // Add this line
    pricing_analysis: historyResult?.pricing_analysis,
    competitors_search: historyResult?.competitors_search_task
  };
  // const handleTrialClick = () => {
  //     dispatch(openModal({
  //         title:"Get access to extended report",
  //         subtitle:"Upgrade to Pro to view extended report. Don't miss out on accessing more insights!",
  //         trial:true,
  //     }));
  // }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (!isProPlan) {
      dispatch(
        openModal({
          title: 'Need to download results?',
          subtitle: "Upgrade to Pro to download results. Don't miss out on accessing your insights!",
          trial: false
        })
      );
      setDownloadClicked(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [stickyTop, setStickyTop] = useState(null);
  const containerRef = useRef(null);
  const sidebarRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current && sidebarRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const sidebarRect = sidebarRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const topMargin = 20;

        // Set the sidebar width when first mounted
        if (sidebarWidth === 0) {
          setSidebarWidth(sidebarRect.width);
        }

        if (containerRect.top <= topMargin) {
          setStickyTop(topMargin);
        } else if (containerRect.top < windowHeight) {
          setStickyTop(containerRect.top);
        } else {
          setStickyTop(null);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Set initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, [sidebarWidth]);

  // External citation highlight: listen for global events and highlight/scroll without affecting chat context
  useEffect(() => {
    const clearExternalHighlights = () => {
      if (!containerRef.current) return;
      const nodes = containerRef.current.querySelectorAll('.external-citation-highlight');
      nodes.forEach((node) => {
        const parent = node.parentNode;
        if (!parent) return;
        parent.replaceChild(document.createTextNode(node.textContent), node);
        parent.normalize();
      });
    };

    const applyExternalHighlight = (text) => {
      if (!containerRef.current || !text) return false;
      const base = String(text).trim();
      if (!base) return false;
      // Build tolerant variants: raw, raw+..., raw+…, swap .../… inside, strip fancy quotes
      const ensureEllipsis = (s) => (/[.…]$/.test(s) || /\.\.\.$/.test(s) ? s : `${s}…`);
      const swapDots = (s) => s.replace(/\.\.\./g, '…');
      const swapEllipsis = (s) => s.replace(/…/g, '...');
      const stripQuotes = (s) => s.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");
      const variants = Array.from(
        new Set([
          base,
          ensureEllipsis(base),
          swapDots(base),
          swapDots(ensureEllipsis(base)),
          swapEllipsis(base),
          stripQuotes(base),
          stripQuotes(ensureEllipsis(base))
        ])
      );
      const walker = document.createTreeWalker(containerRef.current, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while ((node = walker.nextNode())) {
        const content = node.textContent || '';
        const contentLower = content.toLowerCase();
        let foundStart = -1;
        let foundLen = 0;
        for (const v of variants) {
          const vLower = String(v).toLowerCase();
          const i = contentLower.indexOf(vLower);
          if (i !== -1) {
            foundStart = i;
            foundLen = vLower.length;
            break;
          }
        }
        if (foundStart !== -1) {
          try {
            const range = document.createRange();
            range.setStart(node, foundStart);
            range.setEnd(node, foundStart + foundLen);
            const span = document.createElement('span');
            span.className = 'external-citation-highlight';
            span.style.backgroundColor = 'rgba(255, 215, 0, 0.35)';
            span.style.borderRadius = '2px';
            span.style.padding = '1px 2px';
            try {
              range.surroundContents(span);
            } catch (e) {
              span.appendChild(range.extractContents());
              range.insertNode(span);
            }
            // Scroll into view
            setTimeout(() => {
              try {
                span.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } catch (e) {
                /* ignore */
              }
            }, 0);
            return true;
          } catch (e) {
            // continue scanning
          }
        }
      }
      return false;
    };

    const onHighlight = (evt) => {
      const text = evt && evt.detail ? evt.detail.text : '';
      if (!text) return;
      clearExternalHighlights();
      // try exact first, then case-insensitive (already lowercased above)
      if (!applyExternalHighlight(text)) {
        // as a last resort, strip quotes that may differ
        const stripped = String(text)
          .replace(/["'“”]/g, '')
          .trim();
        if (stripped) applyExternalHighlight(stripped);
      }
    };

    const onClear = () => clearExternalHighlights();

    window.addEventListener('lp-analysis:highlight', onHighlight);
    window.addEventListener('lp-analysis:clear-highlight', onClear);
    return () => {
      window.removeEventListener('lp-analysis:highlight', onHighlight);
      window.removeEventListener('lp-analysis:clear-highlight', onClear);
      clearExternalHighlights();
    };
  }, []);

  // Add visual highlighting for selected elements
  useEffect(() => {
    if (containerRef.current) {
      const allCards = containerRef.current.querySelectorAll('.MuiCard-root');

      allCards.forEach((card) => {
        const elementId = generateElementId(card);
        const isSelected = isChatOpen && selectedElements.includes(elementId);

        if (isSelected) {
          card.style.boxShadow = '0 0 0 3px rgba(25, 118, 210, 0.3), 0 4px 20px rgba(25, 118, 210, 0.2)';
          card.style.border = '2px solid #1976d2';
          card.style.transition = 'all 0.3s ease';
        } else {
          card.style.boxShadow = '';
          card.style.border = '';
          card.style.transition = 'all 0.3s ease';
        }
      });
    }
  }, [selectedElements, isChatOpen]); // Added isChatOpen dependency

  // Add visual highlighting for selected text ranges
  useEffect(() => {
    if (containerRef.current) {
      // First, remove all existing text highlights
      const existingHighlights = containerRef.current.querySelectorAll('.text-context-highlight');
      existingHighlights.forEach((highlight) => {
        const parent = highlight.parentNode;
        parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
        parent.normalize();
      });

      // Then add new highlights for current selected text ranges (only if chat is open)
      if (isChatOpen) {
        selectedTextRanges.forEach((textRange) => {
          try {
            const range = document.createRange();

            // Find the nodes using the stored XPath (simplified approach)
            const walker = document.createTreeWalker(containerRef.current, NodeFilter.SHOW_TEXT, null, false);

            let node;
            while ((node = walker.nextNode())) {
              if (node.textContent.includes(textRange.text)) {
                const textIndex = node.textContent.indexOf(textRange.text);
                if (textIndex !== -1) {
                  range.setStart(node, textIndex);
                  range.setEnd(node, textIndex + textRange.text.length);

                  // Create highlight span
                  const highlightSpan = document.createElement('span');
                  highlightSpan.className = 'text-context-highlight';
                  highlightSpan.style.backgroundColor = 'rgba(25, 118, 210, 0.2)';
                  highlightSpan.style.borderRadius = '2px';
                  highlightSpan.style.padding = '1px 2px';
                  highlightSpan.style.transition = 'all 0.3s ease';

                  try {
                    range.surroundContents(highlightSpan);
                  } catch (e) {
                    // If surroundContents fails, try extracting and wrapping
                    highlightSpan.appendChild(range.extractContents());
                    range.insertNode(highlightSpan);
                  }
                  break;
                }
              }
            }
          } catch (error) {
            console.warn('Error applying text highlight:', error);
          }
        });
      }
    }
  }, [selectedTextRanges, isChatOpen]); // Added isChatOpen dependency

  useEffect(() => {
    // Check which data was updated and set the respective state variable

    if (rawAnalysisData !== lastRawAnalysisData) {
      setLastRawAnalysisData(rawAnalysisData);
      setLoadNew(true);
      const task_id = rawAnalysisData.analysis_task_id;
      dispatch(setCurrentTaskId(task_id));
    }

    if (historyResult !== lastHistoryResult) {
      setLastHistoryResult(historyResult);
      setLoadNew(false);
      dispatch(setAnalysisUrl(historyResult.url));
      dispatch(setExtendedAnalysisResults(historyExtendedAnalysisResults));

      // Check if ICP data exists and pass it to the ICP reducer
      if (historyResult?.icp && Object.keys(historyResult.icp).length > 0) {
        const transformedIcpData = {};
        const segments = historyResult.segmentation?.Segments || historyResult.segmentation?.final_segments || [];

        // If historyResult.icp is not an array and we have segments, it's likely a single ICP object.
        // The goal is to map it to a segment_id.
        if (!Array.isArray(historyResult.icp) && segments.length > 0) {
          const firstSegmentId = segments[0]?.segment_id;
          if (firstSegmentId) {
            // Check if the ICP data is the object itself, not keyed by segment_id
            const icpKeys = Object.keys(historyResult.icp);
            const isDirectIcpObject = icpKeys.includes('age') && icpKeys.includes('name');

            if (isDirectIcpObject) {
              transformedIcpData[firstSegmentId] = historyResult.icp;
            } else {
              // It might be already keyed by segment_id, let's trust the structure.
              Object.assign(transformedIcpData, historyResult.icp);
            }
          }
        } else if (Array.isArray(historyResult.icp)) {
          // If it's an array of ICPs, map them to segments by index.
          segments.forEach((segment, idx) => {
            if (historyResult.icp[idx]) {
              transformedIcpData[segment.segment_id] = historyResult.icp[idx];
            }
          });
        } else {
          // Fallback for unexpected structures
          Object.assign(transformedIcpData, historyResult.icp);
        }

        if (Object.keys(transformedIcpData).length > 0) {
          dispatch(
            setIcpHistoryResult({
              url: historyResult.url,
              task_id: historyResult.icp_task_id || historyResult.task_id,
              icps: transformedIcpData,
              segmentation: {
                final_segments: segments,
                core_segmentation_model: historyResult.segmentation?.core_segmentation_model
              }
            })
          );
        }
      }
    }
  }, [rawAnalysisData, historyResult, lastHistoryResult, lastRawAnalysisData, dispatch, historyExtendedAnalysisResults]);

  //   console.log(extendedAnalysisResults)
  if ((!rawAnalysisData || typeof rawAnalysisData !== 'object') && !historyResult) {
    console.log(!rawAnalysisData, typeof rawAnalysisData !== 'object', !historyResult);
    return null;
  } else {
    if (loadNew === null) {
      return null;
    }

    if (loadNew && (!rawAnalysisData?.result || !rawAnalysisData.result[0])) {
      dispatch(
        openSnackbar({
          open: true,
          message: 'Error: Invalid analysis data structure',
          variant: 'alert',
          alert: {
            color: 'error',
            variant: 'filled'
          }
        })
      );
      return null;
    }

    if (!loadNew && (!historyResult?.answer_data?.result || !historyResult.answer_data.result[0])) {
      dispatch(
        openSnackbar({
          open: true,
          message: 'Error: Invalid history result structure',
          variant: 'alert',
          alert: {
            color: 'error',
            variant: 'filled'
          }
        })
      );
      return null;
    }

    const analysisData = loadNew ? rawAnalysisData.result[0] : historyResult.answer_data.result[0];

    if (!analysisData) {
      dispatch(
        openSnackbar({
          open: true,
          message: 'Error: Invalid data structure',
          variant: 'alert',
          alert: {
            color: 'error',
            variant: 'filled'
          }
        })
      );
      return null;
    }

    const downloadDOCX = async () => {
      const fileName = `${analysisData['Service Name']}_analysis.docx`;
      try {
        console.log(analysisData, extendedAnalysisResults, fileName);
        await exportLpAnalysisDocx(analysisData, extendedAnalysisResults, fileName);
      } finally {
        handleClose();
      }
    };

    // const regenerateResults = () => {
    //     dispatch(setLoadingAnswer(true))
    //     processSubmit(lastUrl);
    // }
    // console.log(extendedAnalysisResults);
    // console.log(historyResult);

    return (
      //left part with analysis
      <Grid container sx={{ alignItems: 'center', justifyContent: 'center', px: 2, mx: 'auto', maxWidth: '91.67%' }} ref={containerRef}>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          {isDownloadClicked && <FreeBlockModal />}
          <Stack direction={matchDownSM ? 'column' : 'row'} alignItems="center" justifyContent="center" spacing={2} pb={2} pt={2}>
            {!loadNew ? (
              <Badge badgeContent="History" color="primary" variant="light" sx={{ mr: 1 }}>
                <Typography variant="h3" ml={3} mr={3} align="center" component="div">
                  {analysisData['Service Name']}
                </Typography>
              </Badge>
            ) : (
              <Typography variant="h3" ml={3} align="center" component="div">
                {analysisData['Service Name']}
              </Typography>
            )}

            <Stack direction="row">
              <Tooltip title="Switch view">
                <IconButton size="large" onClick={() => setIsTableView(!isTableView)}>
                  <TableOutlined />
                </IconButton>
              </Tooltip>

              <Tooltip title={!isProPlan ? 'Upgrade to Pro to export' : 'Download'}>
                <div>
                  {!isProPlan ? <Typography variant="body1" color="secondary"></Typography> : null}
                  <IconButton size="large" onClick={handleClick}>
                    <DownloadOutlined />
                  </IconButton>
                </div>
              </Tooltip>

              <Menu
                id="download-menu"
                sx={{
                  border: 1, // sets the border width
                  // borderColor: 'secondary', // use the secondary color from the theme
                  borderRadius: 1 // optional: adds rounded corners
                }}
                disabled={plan === 'Pro' || plan === 'Pro+' || plan === 'Enterprise Pro Max' || plan === 'Enterprise Pro'}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                aria-labelledby="composition-button"
                PaperProps={{
                  sx: {
                    border: 1, // sets the border width
                    borderColor: 'secondary.light', // use the secondary color from the theme
                    borderRadius: 1 // optional: adds rounded corners
                  }
                }}
              >
                <MenuItem disabled={plan === 'Free'} onClick={downloadDOCX}>
                  Download as .docx
                </MenuItem>
              </Menu>
            </Stack>
          </Stack>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={12} lg={12} onMouseUp={isChatOpen ? undefined : undefined}>
            <div id="overview">
              {isTableView ? (
                <Table size="small">
                  <TableBody>
                    {Object.entries(analysisData).map(([key, value]) => (
                      <TableRow key={key}>
                        <TableCell>
                          <Typography variant={matchDownSM ? 'body2' : 'h6'} component="div" style={{ fontWeight: 'bold' }}>
                            {key}:
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant={matchDownSM ? 'body2' : 'body1'}
                            // component="span"
                          >
                            {value}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <NewOverviewSection analysisData={analysisData} />
              )}
            </div>

            {extendedAnalysisResults ? (
              <>
                {/* <PricingAnalysisSection pricingAnalysis={extendedAnalysisResults.pricing_analysis} handleTrialClick={handleTrialClick} serviceName={analysisData["Service Name"]} /> */}
                <ExtendedAnalysisGroup analysisData={analysisData} processSubmit={processSubmit} />
              </>
            ) : null}
          </Grid>

          {!matchDownMD && (
            <Grid
              item
              xs={12}
              sm={3}
              md={3.5}
              lg={3.5}
              sx={{
                position: 'relative',
                height: '100%'
              }}
            >
              <Box
                ref={sidebarRef}
                sx={{
                  position: stickyTop !== null ? 'fixed' : 'static',
                  top: stickyTop !== null ? `${stickyTop}px` : 'auto',
                  width: stickyTop !== null ? `${sidebarWidth}px` : '100%',
                  maxHeight: 'calc(100vh - 0px)',
                  overflowY: 'auto'
                }}
              >
                {/* <PremiumUnlockGroup
                  sections={sections}
                  isPaid={isNotFreePlan}
                  onTrialClick={() => {
                    // Track the event with Yandex Metrika
                    if (window.ym) {
                      window.ym(94496474, 'reachGoal', 'TOP_RIGHT_TABLE_TRIAL_CLICK');
                    }
                    // Dispatch modal
                    dispatch(
                      openModal({
                        title: 'Get access to extended report',
                        subtitle: "Upgrade to Pro to view extended report. Don't miss out on accessing more insights!",
                        trial: true
                      })
                    );
                  }}
                /> */}
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
};

export default AnalysisOutputGroup;
